import React, { useState }          from 'react';
import { Alert, Fade, Nav, Tab }    from 'react-bootstrap';
import { useSelector }              from 'react-redux';

import AccusedResultsInfo           from './view/AccusedResultsInfo';
import ActuationsList               from './work/treatment/ActuationsList';
import AudienceAccuseds             from './work/info/AudienceAccuseds';
import AudienceIntervenings         from './work/info/AudienceIntervenings';
import AudienceMotives              from './work/info/AudienceMotives';
import AudienceNotifications        from './work/AudienceNotifications';
import AudienceVictims              from './work/info/AudienceVictims';
import AuthoritiesService           from '../../services/AuthoritiesService';

import JudgesInfo                   from './view/JudgesInfo';
import ProceedingInfo               from './view/ProceedingInfo';
import RequestInfo                  from './view/RequestInfo';
import ResultsInfo                  from './view/ResultsInfo';
import SchedulingInfo               from './view/SchedulingInfo';


import { CANCELADA, RECHAZADA }     from '../../data/audienceStates';
import { NOTIFICACIONES_LISTAR }    from '../../data/objects';




const AudienceViewInfo = () => {
    
    // Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    const authorities = useSelector(state => state.auth.authorities);
    
    // Inicializo el state local
    const [key, setKey] = useState("1");
    const [readOnly, setReadOnly] = useState(true);
    
    // Manejo el select
    const handleSelectTab = tab => {
        setKey(tab);
    }

    // Renderizo
    return (
        <React.Fragment>
            {   audience 
                    ? 
                        <Tab.Container
                            transition = { Fade }
                            activeKey = { key }
                        >
                            <div className="col-md-12 mb-2">
                                <Nav variant="pills" activeKey="1">
                                    <Nav.Item>
                                        <Nav.Link eventKey="1" onClick={() => handleSelectTab("1")}>
                                            Datos Solicitud
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="2" onClick={() => handleSelectTab("2")}>
                                            Datos Legajo
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="3" onClick={() => handleSelectTab("3")}>
                                            Intervinientes
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="4" onClick={() => handleSelectTab("4")}>
                                            Agendamiento
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="5" onClick={() => handleSelectTab("5")}>
                                            Resultados
                                        </Nav.Link>
                                    </Nav.Item>
                                    {   authorities && AuthoritiesService.hasPermission(authorities, NOTIFICACIONES_LISTAR)
                                            ?
                                                <Nav.Item>
                                                    <Nav.Link eventKey="6" onClick={() => handleSelectTab("6")}>
                                                        Notificaciones
                                                    </Nav.Link>
                                                </Nav.Item>
                                            :
                                                null
                                    }
                                </Nav>
                            </div>
                            <div className="col-md-12">
                                <Tab.Content>
                                    <Tab.Pane eventKey="1" transition={Fade}>
                                        <div className="row">
                                            <div className="col-12">
                                                <Alert variant={ audience.estado.css }>
                                                    Estado Audiencia: <strong>{ audience.estado.descripcion.toUpperCase() }</strong>
                                                </Alert>
                                            </div>
                                            {   audience && (audience.estado.id === RECHAZADA || audience.estado.id === CANCELADA) 
                                                    ? 
                                                        <AudienceMotives audience={audience} />
                                                    : 
                                                        null
                                            }
                                            <RequestInfo />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="2" transition={Fade}>
                                        <div className="row">
                                            <ProceedingInfo />
                                            <ActuationsList audience={audience} />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="3" transition={Fade}>
                                        <div className="row">
                                            <AudienceAccuseds audience={audience} />
                                            <AudienceVictims audience={audience} />
                                            <AudienceIntervenings audience={audience} />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="4" transition={Fade}>
                                        <div className="row">
                                            <SchedulingInfo />
                                            <JudgesInfo />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="5" transition={Fade}>
                                        <div className="row">
                                            <ResultsInfo />
                                            <AccusedResultsInfo />
                                        </div>
                                    </Tab.Pane>
                                    {   authorities && AuthoritiesService.hasPermission(authorities, NOTIFICACIONES_LISTAR)
                                            ?
                                                <Tab.Pane eventKey="6" transition={Fade}>
                                                    <AudienceNotifications readOnly={readOnly} />
                                                </Tab.Pane>
                                            :
                                                null
                                    }
                                </Tab.Content>
                            </div>
                        </Tab.Container>       
                    :
                        'Cargando datos...'
            }
        </React.Fragment>
    );
};

export default AudienceViewInfo;